import GenericRequest, { METHOD_GET } from '../../../../webservices/GenericRequest';

export class QrWorkerTokenTask extends GenericRequest {

    _request; // QrWorkerTokenRequest

    constructor(request) {
        super(METHOD_GET, request.route());
    }

    overrideRequest() {}

}



// WEBPACK FOOTER //
// ./src/app/shared/components/predefined-fields/resource-contractor-schema/worker-qr/QrWorkerTokenTask.js